enum Role {
    Administrator = 'ADMINISTRATOR',
    PointsAdministrator = 'POINTS_ADMINISTRATOR',
    Integrator = 'INTEGRATOR',
    Commercial = 'COMMERCIAL',
    CommercialSupervisor = 'COMMERCIAL_SUPERVISOR',
    Financial = 'FINANCIAL',
    TechnicalSupport = 'TECHNICAL_SUPPORT',
    Logistics = 'LOGISTICS',
    CustomerSuccess = 'CUSTOMER_SUCCESS',
    ShippingCompany = 'SHIPPING_COMPANY',
    Purchase = 'PURCHASE',
    Manager = 'MANAGER',
    Contributor = 'CONTRIBUTOR',
    Registration = 'REGISTRATION',
    Production = 'PRODUCTION',
    Marketing = 'MARKETING',
}

export default Role;
